import React from "react";
import { ExperimentCard, Hero } from "../../components";

const CARDS = [
  {
    title: "Agarose gel electrophoresis  	",
    link: "https://static.igem.wiki/teams/4577/wiki/project/experiments/agarose-gel-electrophoresis-protocol.pdf",
  },
  {
    title: "DNA Ligation  	",
    link: "https://static.igem.wiki/teams/4577/wiki/project/experiments/dna-ligation-protocol.pdf",
  },
  {
    title: "Colony PCR  	",
    link: "https://static.igem.wiki/teams/4577/wiki/project/experiments/colony-pcr-protocol.pdf",
  },
  {
    title: "Plasmid Digestion 	",
    link: "https://static.igem.wiki/teams/4577/wiki/project/experiments/plasmid-digestion-protocol.pdf",
  },
  {
    title:
      "AOX_3introns assembly from AOX_part1, 2 & 3, Biobricks, pPSAD and tPSAD  	",
    link: "https://static.igem.wiki/teams/4577/wiki/project/experiments/aox-3introns-assembly-from-aox-part1-2-3-biobricks-ppsad-and-tpsad-protocol.pdf",
  },
  {
    title:
      " C. reinhardtii plasmid assembly by using the NEBridge® Golden Gate Assembly Kit (BsaI-HF®v2) (E1601) 	",
    link: "https://static.igem.wiki/teams/4577/wiki/project/experiments/c-reinhardtii-plasmid-assembly-by-using-the-nebridge-golden-gate-assembly-kit-bsai-hf-v2-e1601-protocol.pdf",
  },
  {
    title: "C. reinhardtii immunofluorescence assay  	",
    link: "https://static.igem.wiki/teams/4577/wiki/project/experiments/c-reinhardtii-immunofluoresence-assay-protocol.pdf",
  },
  {
    title: " Monarch® Plasmid DNA Miniprep Kit (NEB #T1010) 	",
    link: "https://static.igem.wiki/teams/4577/wiki/project/experiments/monarch-plasmid-dna-miniprep-kit-protocol-neb-t1010.pdf",
  },
  {
    title: "PCR by using Q5® High-Fidelity 2X Master Mix 	",
    link: "https://static.igem.wiki/teams/4577/wiki/project/experiments/pcr-by-using-q5-high-fidelity-2x-master-mix.pdf",
  },
  {
    title: " RT-PCR by using OneTaq® RT-PCR Kit Protocol ",
    link: "https://static.igem.wiki/teams/4577/wiki/project/experiments/pcr-by-using-q5-high-fidelity-2x-master-mix-protocol.pdf",
  },
  {
    title: "QIAquick® Gel Extraction Kit and QIAquick® PCR & Gel Cleanup Kit  	",
    link: "https://static.igem.wiki/teams/4577/wiki/project/experiments/qiaquick-gel-extraction-kit-and-qiaquick-pcr-gel-cleanup-kit-protocol.pdf",
  },
  {
    title: "Use iGEM Linearized Plasmid Backbones 	",
    link: "https://static.igem.wiki/teams/4577/wiki/project/experiments/use-igem-linearized-plasmid-backbones-protocol.pdf",
  },
  {
    title: " Culture of C. reinhardtii  	",
    link: "https://static.igem.wiki/teams/4577/wiki/project/experiments/culture-of-c-reinhardtii-protocol.pdf",
  },
  {
    title: "Co-culture C. reinhardtii and S. meliloti  	",
    link: "https://static.igem.wiki/teams/4577/wiki/project/experiments/co-culture-c-reinhardtii-and-s-meliloti-protocol.pdf",
  },
  {
    title: "C. reinhardtii and S. meliloti adapatation in synthetic medias",
    link: "https://static.igem.wiki/teams/4577/wiki/project/experiments/c-reinhardtii-and-s-meliloti-adaptation-in-synthetic-medias-protocol.pdf",
  },
  {
    title: "C. reinhardtii transformation by using electroporation method",
    link: "https://static.igem.wiki/teams/4577/wiki/project/experiments/c-reinhardtii-transformation-by-using-electroporation-method-protocol.pdf",
  },
  {
    title: "S. meliloti transformation by using electroporation method",
    link: "https://static.igem.wiki/teams/4577/wiki/project/experiments/s-meliloti-transformation-by-using-electroporation-method-protocol.pdf",
  },
  {
    title: " E. coli DH5α transformation by using heat shock method",
    link: "https://static.igem.wiki/teams/4577/wiki/project/experiments/e-coli-dh5-transformation-by-using-heat-shock-method.pdf",
  },
  {
    title: "LB and LBMC media preparation",
    link: "https://static.igem.wiki/teams/4577/wiki/project/experiments/lb-and-lbmc-media-preparation-protocol.pdf",
  },
  {
    title: "TAP media preparation",
    link: "https://static.igem.wiki/teams/4577/wiki/project/experiments/tap-media-preparation-protocol.pdf",
  },
  {
    title: "Synthetic Wastewater and Urine medias preparation",
    link: "https://static.igem.wiki/teams/4577/wiki/project/experiments/synthetic-wastewater-and-urine-medias-preparation-protocol.pdf",
  },
  {
    title: "Freezing of bacteria cultures at -80°C",
    link: "https://static.igem.wiki/teams/4577/wiki/project/experiments/freezing-of-bacteria-cultures-at-80-c-protocol.pdf",
  },
  {
    title: "Bacteria counting",
    link: "https://static.igem.wiki/teams/4577/wiki/project/experiments/bacteria-count-protocol.pdf",
  },
];

function Experiments() {
  return (
    <div className="flex overflow-x-hidden overflow-y-hidden relative flex-col -z-10">
      <Hero title={"Experiments"}>
        Experiments are the stepping stones of discovery, and protocols are the
        carefully{" "}
        <span className="text-lg font-black text-RougePastel md:text-xl lg:text-2xl">
          crafted paths
        </span>{" "}
         we tread upon.
      </Hero>

      <div className="flex w-full px-[24px] md:px-[70px] justify-center items-center">
        <div className="flex justify-center items-center mx-auto flex-col md:max-w-[1500px] gap-[30px]">
          <div
            className="flex mx-auto w-full text-justify md:text-lg"
            id="page-content"
          >
            All the protocols we used to carry out our project are presented
            below.
          </div>

          <div className="flex justify-center items-center w-full bg-white">
            <div className="grid grid-cols-2 md:grid-cols-3  lg:grid-cols-5 py-[50px] md:max-w-[1500px] lg:gap-10 gap-8">
              {CARDS.map((elt, idx) => {
                return <ExperimentCard key={idx} {...elt} />;
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Experiments;
